import { IRootState } from '../../../../store'
import { IEmployerState } from '../store/employer.types'

export const getEmployerSelector = (state: IRootState): IEmployerState => state.employer
